import { render, staticRenderFns } from "./massey-ferguson.vue?vue&type=template&id=8788bd9e&"
import script from "./massey-ferguson.vue?vue&type=script&lang=js&"
export * from "./massey-ferguson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports